const load = async ({ url, setHeaders }) => {
  setHeaders({ "Cache-Control": "public, max-age=3600, must-revalidate" });
  return { url: url.pathname };
};
export {
  load
};
